export default __webpack_public_path__ + "static/media/researchPage.dff775ac.png";